/**
 * filter.types.ts - Filter Type Definitions
 */

export interface FilterOption {
    label: string;
    value: string;
    count: number;
    displayLabel: string;
}

export interface FilterSuggestions {
    authors: FilterOption[];
    persons: FilterOption[];
    organizations: FilterOption[];
    locations: FilterOption[];
    categoryCodes: FilterOption[];
    tags: FilterOption[];
}

export interface DateRangeFilter {
    customFrom?: string | null // ISO date string;
    customTo?: string | null // ISO date string;
}

export interface ActiveFilters {
    dateRange: DateRangeFilter;
    authors: string[];
    persons: string[];
    organizations: string[];
    locations: string[];
    categoryCodes: string[];
}

export const EMPTY_FILTERS: ActiveFilters = {
    dateRange: {
        customFrom: null,
        customTo: null,
    },
    authors: [],
    persons: [],
    organizations: [],
    locations: [],
    categoryCodes: [],
};

export interface DeweyNode {
    code: string;
    label: string;
    children: DeweyNode[];
    level: number;
}

export interface FilterAPIRequest {
    circleId: string | string[];
    maxBuckets: number;
    searchQuery: string;
}

export interface FilterAPIResponse {
    authors?: FilterOption[];
    persons?: FilterOption[];
    organizations?: FilterOption[];
    locations?: FilterOption[];
    categoryCodes?: FilterOption[];
    tags?: FilterOption[];
}

